import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Nav, { NavItem } from 'tbk-components/src/components/Nav';

// Represents a link in the language selector drop-down
export type LanguageNavItem = {
	href: string;
	label: string;
	target?: string;
	icon?: string;
	code?: string;
	locale?: string;
};

export interface IFooterCalloutNavigationProps extends IBaseElementProps {
	logo?: IImage;
	logoURL?: string;
	calloutNavigation?: NavItem[];
}

const FooterCalloutNavigation: React.FC<IFooterCalloutNavigationProps> =
	({ className, classNames = [], logo, logoURL, calloutNavigation }) => (
		<div
			className={
				className ||
				cn('calian-footer__callout container-fluid', ...classNames)
			}
		>
			<div className="calian-footer__callout--content">
				{logo && logoURL && (
					<a
						className="calian-footer__callout--logo navbar-brand"
						href={logoURL}
					>
						<Image {...logo} className="img-fluid" />
					</a>
				)}
				<Nav
					navItems={calloutNavigation}
					collapseEnabled={false}
					dropdownEnabled={true}
					classNames={['calian-footer__callout--nav']}
				/>
			</div>
		</div>
	);

export default FooterCalloutNavigation;
